import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Api } from "../../services/api";

const AllPerformanceHuddle = () => {
    const toast = useRef(null);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);

    const [projects, setProjects] = useState([]);

    const [selectedProduct, setSelectedProduct] = useState(null);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            project_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            first_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            last_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            ProjectType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },

        });
        setGlobalFilterValue('');
    };

    /** search Filtter function End */

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between m-2">
            <div></div>
            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field"
                    type="search"
                    value={globalFilterValue} onChange={onGlobalFilterChange}
                    // onChange={(e) => searchproject(e.target.value)}
                    placeholder="Search..."
                />
            </span>
        </div>
    );


    useEffect(() => {
        getProjectDetails();
        initFilters();
        return () => {

        };
    }, []);

    const getProjectDetails = () => {
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(Api.API_BASE_URL + 'pm-template/performance-points-getall', {
            method: "GET",
            headers: headers,
        })
            .then((response) => response.json())
            .then((response) => {

                setProjects(response.result);
                setIsLoading(false);


                //* -------------Back Button Function Start------------------------------

                let playbookRedirect = localStorage.getItem('performanceHuddleHistoryRedirect');
                if (playbookRedirect) {
                    playbookRedirect = JSON.parse(playbookRedirect)
                    setFirst(playbookRedirect.first || 0)
                    setRows(playbookRedirect.rows || 12)
                    setSortField(playbookRedirect.sortField || 'project_name')
                    setSortOrder(playbookRedirect.sortOrder || -1)

                } let playbookSelectedProduct = localStorage.getItem('performanceHuddleHistorySelectedProduct');
                if (playbookSelectedProduct) {
                    playbookSelectedProduct = JSON.parse(playbookSelectedProduct)
                    setSelectedProduct(playbookSelectedProduct)


                }

                localStorage.removeItem('performanceHuddleHistoryRedirect')
                localStorage.removeItem('performanceHuddleHistorySelectedProduct');
                //! -------------Back Button Function End------------------------------

            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);

            });
    }




    // const edit = (rowData) => {
    //     if (rowData.performanceType === "pm") {
    //         var url = rowData.type + '-' + rowData.user_id + '-' + rowData.role_id + '-' + rowData.first_name + '-' + rowData.last_name;
    //         navigate('/performance-huddle-view/' + url);
    //     } else if (rowData.performanceType === "fp") {
    //         navigate('/ac-fa-controller/view/' + rowData.user_id + '/' + rowData.role_id);
    //     } else if (rowData.performanceType === "vp") {
    //         navigate('/vp-sales-and-marketing/view/' + rowData.user_id + '/' + rowData.role_id);
    //     }
    // }

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(12);
    const [sortField, setSortField] = useState('project_name');
    const [sortOrder, setSortOrder] = useState(-1);
    const fetchData = async (event) => {
        const { first, rows, sortField, sortOrder } = event;
        setFirst(first);
        setRows(rows);
        setSortField(sortField);
        setSortOrder(sortOrder);
    }
    const onRowSelect = (e) => {
        console.log(e.data)
        const rowData = e.data;
        localStorage.setItem('performanceHuddleHistoryRedirect', JSON.stringify({
            rows: rows,
            first: first,
            sortField: sortField,
            sortOrder: sortOrder,

        }))

        localStorage.setItem('performanceHuddleHistorySelectedProduct', JSON.stringify(rowData))
        
        const roleName = (rowData.role_name || "").toLowerCase();

        if (roleName.includes("financial") || roleName.includes("account") || roleName.includes("controller")) {
            navigate('/ac-fa-controller/view/' + rowData._id + '/' + rowData.role_id);
        } else if (roleName.includes("sales") || roleName.includes("marketing")) {
            navigate('/vp-sales-and-marketing/view/' + rowData._id + '/' + rowData.role_id);
        } else {
            var url = 'projectManager-' + rowData._id + '-' + rowData.role_id + '-' + rowData.first_name + '-' + rowData.last_name + '-' + rowData.role_name;
            navigate('/performance-huddle-view/' + url);
        }
    };


    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <div className="one-line-container">

            </div>
            {isLoading ? (
                <div className="loading-spinner">
                    Loading...
                    <div className="spinner"></div>
                </div>
            ) : (

                <div className="pagination-datable-height">
                    {/* <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                        <TabPanel header="" className="p-2 pb-2" > */}
                    <div className=" m-0" style={{ width: "100%" }} >

                        <DataTable
                            value={projects}
                            paginator
                            // rows={12}
                            // dataKey="id"
                            rows={rows}
                            first={first}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onPage={fetchData}
                            onSort={fetchData}


                            selection={selectedProduct}
                            onRowSelect={onRowSelect}
                            onRowUnselect={onRowSelect}

                            // onSelectionChange={(e) => edit(e.value)}
                            selectionMode="single"
                            header={header}
                            filters={filters}
                            globalFilterFields={['date', 'month', 'month', 'first_name', 'last_name']}
                        >
                            <Column header="Sr.No" body={(data, options) => options.rowIndex + first + 1} className="h-3rem" ></Column>
                            <Column header="First Name" field="first_name" body={(e) => <span>{e.first_name}</span>} className="h-3rem" ></Column>
                            <Column header="Last Name" field="last_name" body={(e) => <span>{e.last_name}</span>} className="h-3rem" ></Column>
                            <Column header="Email" field="email"  className="h-3rem col-padding" ></Column>
                            <Column header="Role" field="role_name"  className="h-3rem col-padding" ></Column>
                        </DataTable>
                    </div>
                    {/* </TabPanel>
                    </TabView> */}
                </div>
            )}
        </>
    )
}

export default AllPerformanceHuddle;